import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { useDispatch } from 'react-redux';
import store from './redux/store';
import { fetchAllData } from './redux/actions/dataActions';
import { AuthProvider, useAuth } from './pages/Admin/context/AuthContext';
import visitorService from './services/visitorService';

// Components
import Header from './components/Layout/Header';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

// Admin Components
import AdminLayout from './pages/Admin/components/AdminLayout';
import LoginPage from './pages/Admin/components/LoginPage';
import Dashboard from './pages/Admin/pages/Dashboard';
import KelolaProfil from './pages/Admin/pages/KelolaProfil';
import KelolaLayanan from './pages/Admin/pages/KelolaLayanan';
import ManajemenUser from './pages/Admin/pages/ManajemenUser';
import ManajemenRole from './pages/Admin/pages/ManajemenRole';
import ManajemenMenu from './pages/Admin/pages/ManajemenMenu';
import ManajemenArtikel from './pages/Admin/pages/ManajemenArtikel';
import ManajemenFrontendMenu from './pages/Admin/pages/ManajemenFrontendMenu';
import PPIDContentForm from './pages/Admin/components/PPIDContentForm';
import ManajemenAPBD from './pages/Admin/pages/ManajemenAPBD';
import ManajemenVisiMisi from './pages/Admin/pages/ManajemenVisiMisi';
import ManajemenTupoksi from './pages/Admin/pages/ManajemenTupoksi';
import ManajemenStrukturOrganisasi from './pages/Admin/pages/ManajemenStrukturOrganisasi';
import ManajemenStandarPelayanan from './pages/Admin/pages/ManajemenStandarPelayanan';
import ManajemenMaklumatPelayanan from './pages/Admin/pages/ManajemenMaklumatPelayanan';
import ManajemenProdukHukum from './pages/Admin/pages/ManajemenProdukHukum';
import LayananRedirect from './pages/Layanan/LayananRedirect';
import ManajemenKontak from './pages/Admin/pages/ManajemenKontak';
import AgendaPage from './pages/Informasi/AgendaPage';
import ManajemenAgenda from './pages/Admin/pages/ManajemenAgenda';
import ManajemenSlider from './pages/Admin/pages/ManajemenSlider';
import ManajemenSambutan from './pages/Admin/pages/ManajemenSambutan';
import ManajemenPerizinanIpt from './pages/Admin/pages/ManajemenPerizinanIpt';
import ManajemenPermohonanIpt from './pages/Admin/pages/ManajemenPermohonanIpt';
import ManajemenSewaGedung from './pages/Admin/pages/ManajemenSewaGedung';
import ManajemenPermohonanSewaGedung from './pages/Admin/pages/ManajemenPermohonanSewaGedung';
import ManajemenSewaKendaraan from './pages/Admin/pages/ManajemenSewaKendaraan';
import ManajemenPermohonanSewaKendaraan from './pages/Admin/pages/ManajemenPermohonanSewaKendaraan';
import KebijakanPrivasiButton from './components/Home/KebijakanPrivasiButton';

// Home Components
import Popup from './components/Home/Popup';
import Slider from './components/Home/Slider';
import Informasi from './components/Home/Informasi';
import LayananUtama from './components/Home/LayananUtama';
import PanduanLayanan from './components/Home/PanduanLayanan';
import LayananPenunjang from './components/Home/LayananPenunjang';
import BeritaTerkini from './components/Home/BeritaTerkini';
import AgendaTerkini from './components/Home/AgendaTerkini';
import DokumentasiKegiatan from './components/Home/DokumentasiKegiatan';
import Jejaring from './components/Home/Jejaring';
import BeritaDetail from './pages/BeritaDetail';
import AgendaDetail from './pages/AgendaDetail';

// Pages
import VisiMisi from './pages/Profil/VisiMisi';
import Tupoksi from './pages/Profil/Tupoksi';
import StrukturOrganisasi from './pages/Profil/StrukturOrganisasi';
import StandarPelayanan from './pages/Profil/StandarPelayanan';
import RetribusiIPT from './pages/Layanan/RetribusiIPT';
import RetribusiIPR from './pages/Layanan/RetribusiIPR';
import PerizinanIPT from './pages/Layanan/PerizinanIPT';
import AjukanPermohonanIPT from './pages/Layanan/AjukanPermohonanIPT';
import AjukanPermohonanIPR from './pages/Layanan/AjukanPermohonanIPR';
import HBGHPL from './pages/Layanan/HBGHPL';
import SewaBMD from './pages/Layanan/SewaBMD';
import SewaGedung from './pages/Layanan/SewaGedung';
import PanggungCreativa from './pages/Layanan/PanggungCreativa';
import SuketMandiri from './pages/Layanan/SuketMandiri';
import SuratPerizinan from './pages/Layanan/SuratPerizinan';
import APBDPage from './pages/APBD/APBDPage';
import InformasiPage from './pages/Informasi/InformasiPage';
import PPIDPage from './pages/Informasi/PPIDPage';
import ProdukHukumPage from './pages/Informasi/ProdukHukumPage';
import ArtikelPage from './pages/Informasi/ArtikelPage';
import KontakPage from './pages/Kontak/KontakPage';
import AduanPage from './pages/Aduan/AduanPage';
import FAQPage from './pages/FAQ/FAQPage';
import BidangPage from './pages/Bidang/BidangPage';
import Sambutan from './components/Home/Sambutan';
import AccessibilityMenu from './components/Accessibility/AccessibilityMenu';
import SurveyPage from './pages/Survey/SurveyPage';
import MaklumatPelayanan from './pages/Profil/MaklumatPelayanan';
import LaporanIKM from './pages/Profil/LaporanIKM';

// Protected Route Component - DIPINDAHKAN KE DALAM AuthProvider
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0D9488] mx-auto mb-4"></div>
          <p className="text-gray-500">Memuat...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return children;
};

// Admin Routes Component
const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/*" element={
        <ProtectedRoute>
          <AdminLayout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/profil/:section?" element={<KelolaProfil />} />
              <Route path="/layanan" element={<KelolaLayanan />} />
              <Route path="/layanan/tambah" element={<KelolaLayanan />} />
              <Route path="/users" element={<ManajemenUser />} />
              <Route path="/roles" element={<ManajemenRole />} />
              <Route path="/menus" element={<ManajemenMenu />} />
              <Route path="/artikel" element={<ManajemenArtikel />} />
              <Route path="/frontend-menus" element={<ManajemenFrontendMenu />} />
              <Route path="/ppid-contents" element={<PPIDContentForm />} />
              <Route path="/apbd" element={<ManajemenAPBD />} />
              <Route path="/visi-misi" element={<ManajemenVisiMisi />} />
              <Route path="/tupoksi" element={<ManajemenTupoksi />} />
              <Route path="/struktur-organisasi" element={<ManajemenStrukturOrganisasi />} />
              <Route path="/standar-pelayanan" element={<ManajemenStandarPelayanan />} />
              <Route path="/maklumat-pelayanan" element={<ManajemenMaklumatPelayanan />} />
              <Route path="/produk-hukum" element={<ManajemenProdukHukum />} />
              <Route path="/kontak" element={<ManajemenKontak />} />
              <Route path="/agenda" element={<ManajemenAgenda />} />
              <Route path="/slider" element={<ManajemenSlider />} />
              <Route path="/sambutan" element={<ManajemenSambutan />} />
              <Route path="/perizinan-ipt" element={<ManajemenPerizinanIpt />} />
              <Route path="/perizinan-ipt-permohonan" element={<ManajemenPermohonanIpt />} />
              <Route path="/sewa-gedung" element={<ManajemenSewaGedung />} />
              <Route path="/sewa-gedung-permohonan" element={<ManajemenPermohonanSewaGedung />} />
              <Route path="/sewa-kendaraan" element={<ManajemenSewaKendaraan />} />
              <Route path="/sewa-kendaraan-permohonan" element={<ManajemenPermohonanSewaKendaraan />} />
              <Route path="*" element={<Navigate to="/admin" />} />
            </Routes>
          </AdminLayout>
        </ProtectedRoute>
      } />
    </Routes>
  );
};

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 p-3 bg-teal-600 text-white rounded-full shadow-lg hover:bg-teal-700 transition duration-300 z-50"
        aria-label="Kembali ke atas"
      >
        {/* Ikon panah ke atas (SVG) */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 15l7-7 7 7"
          />
        </svg>
      </button>
    )
  );
};

// Home Page Component
const HomePage = () => {
  return (
    <>
      <Popup />
      <Slider />
      <Sambutan />
      <Informasi />
      <PanduanLayanan />
      <LayananPenunjang />
      <AgendaTerkini />
      <BeritaTerkini />
      <DokumentasiKegiatan />
      <Jejaring />
      <ScrollToTopButton />
      <KebijakanPrivasiButton />
    </>
  );
};

// Main App Content with Redux
const AppContent = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(fetchAllData());
  }, [dispatch]);

  useEffect(() => {
    // Track setelah delay 2 detik (hindari spam)
    const timer = setTimeout(() => {
      visitorService.trackVisit(location.pathname);
    }, 2000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <a href="#main-content" className="skip-to-content">
        Lewati ke konten utama
      </a>
      <AccessibilityMenu />
      <Header />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />

        {/* Profil Routes */}
        <Route path="/profil/visi-misi" element={<VisiMisi />} />
        <Route path="/profil/tupoksi" element={<Tupoksi />} />
        <Route path="/profil/struktur-organisasi" element={<StrukturOrganisasi />} />
        <Route path="/profil/standar-pelayanan" element={<StandarPelayanan />} />
        <Route path="/profil/maklumat-pelayanan" element={<MaklumatPelayanan />} />
        <Route path="/profil/laporan-ikm" element={<LaporanIKM />} />

        {/* Layanan Routes */}
        <Route path="/layanan/retribusi-ipt" element={<RetribusiIPT />} />
        <Route path="/layanan/retribusi-ipr" element={<RetribusiIPR />} />
        <Route path="/layanan/ajukan-permohonan-ipt" element={<AjukanPermohonanIPT />} />
        <Route path="/layanan/ajukan-permohonan-ipr" element={<AjukanPermohonanIPR />} />
        <Route path="/layanan/ipt" element={<PerizinanIPT />} />
        <Route path="/layanan/hbg-hpl" element={<HBGHPL />} />
        <Route path="/layanan/sewa-bmd" element={<SewaBMD />} />
        <Route path="/layanan/siwage" element={<SewaGedung />} />
        <Route path="/layanan/sewa-gedung" element={<SewaGedung />} />
        <Route path="/layanan/panggung-creativa" element={<PanggungCreativa />} />
        <Route path="/layanan/suket-mandiri" element={<SuketMandiri />} />
        <Route path="/layanan/surat-perizinan" element={<SuratPerizinan />} />
        <Route path="/layanan/perizinan-aset-ipt" element={<PerizinanIPT />} />
        <Route path="/layanan/informasi-status-tanah" element={<PerizinanIPT />} />
        <Route path="/layanan/surat-keterangan" element={<SuketMandiri />} />
        <Route path="/layanan/sewa-aset-kosong" element={<SewaBMD />} />
        <Route path="/layanan/pusat-bantuan" element={<KontakPage />} />

        {/* Bidang Routes */}
        <Route path="/bidang/:bidangId" element={<BidangPage />} />

        {/* Informasi Routes */}
        <Route path="/informasi" element={<InformasiPage />} />
        <Route path="/informasi/ppid/:category?" element={<PPIDPage />} />
        <Route path="/informasi/produk-hukum/:category?" element={<ProdukHukumPage />} />
        <Route path="/informasi/artikel/:category?" element={<ArtikelPage />} />
        <Route path="/informasi/artikel/detail/:id/:slug" element={<BeritaDetail />} />

        {/* Other Routes */}
        <Route path="/apbd" element={<APBDPage />} />
        <Route path="/kontak" element={<KontakPage />} />
        <Route path="/aduan" element={<AduanPage />} />
        <Route path="/faq" element={<FAQPage />} />

        {/* Admin Routes - Redirect to admin module */}
        <Route path="/admin/*" element={<Navigate to="/admin" />} />
        <Route path="/survey" element={<SurveyPage />} />

        <Route path="/berita/:id" element={<BeritaDetail />} />
        <Route path="/agenda/:id" element={<AgendaDetail />} />

        <Route path="/layanan/redirect/:slug" element={<LayananRedirect />} />

        <Route path="/informasi/agenda" element={<AgendaPage />} />
        <Route path="/informasi/agenda/:slug" element={<AgendaPage />} />
      </Routes>

      <Footer />
    </div>
  );
};

// Main App Component
function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Admin Routes - Without Header/Footer */}
            <Route path="/admin/*" element={<AdminRoutes />} />

            {/* Public Routes - With Header/Footer */}
            <Route path="/*" element={<AppContent />} />
          </Routes>
        </Router>
      </AuthProvider>
    </Provider>
  );
}

export default App;